import React from 'react';
import { projectionChartSliderPlugin } from './projectionChartSliderPlugin';
import { createProjectionProviderPlugin } from './projectionProvider';
export function useChartjsProjectionChart() {
    const projectionChartRef = React.useRef(null);
    const projectionChartOnInstallRef = React.useRef(() => false);
    const projectionChartConfig = React.useMemo(() => ({
        type: 'line',
        data: {
            datasets: [],
        },
        options: {
            events: ['mousedown', 'mouseup', 'mousemove', 'mouseout'],
            scales: {},
            plugins: {
                projectionChart: {
                    onInstall(chart) {
                        projectionChartRef.current = chart;
                        projectionChartOnInstallRef.current(chart);
                    },
                },
            },
            layout: {
                padding: {},
            },
        },
        plugins: [
            projectionChartSliderPlugin,
        ],
    }), []);
    const provideForProjectionChartPlugin = React.useMemo(() => createProjectionProviderPlugin({
        getProjectionChart: () => projectionChartRef.current,
        onProjectionInstall: (callback) => {
            projectionChartOnInstallRef.current = callback;
        },
    }), []);
    return { provideForProjectionChartPlugin, projectionChartConfig };
}
//# sourceMappingURL=useChartjsProjectionChart.js.map
